import { useState } from 'react'
import axios from 'axios'
import api from '../../utils/api'
import cookies from '../../utils/cookies'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const baseURL = process?.env?.REACT_APP_API_URL || 'http://localhost:8000'

const useReservationsReportApi = () => {
  const addToast = useToastContext()

  const [reportState, setReportState] = useState({
    report: null,
    isLoading: false,
    error: null,
  })

  async function generateReport(params) {
    try {
      setReportState((current) => ({ ...current, isLoading: true, error: null }))
      const response = await api.get('/reservations/report', {
        params,
        includeToken: true,
      })
      setReportState({ report: response.data, isLoading: false, error: null })
      return response.data
    } catch (error) {
      setReportState({
        report: null,
        isLoading: false,
        error: error.response?.data?.message || 'Error al generar reporte',
      })
      addToast(
        notificationTypes.error,
        error.response?.data?.message || 'Error al generar reporte'
      )
    }
  }

  // The PDF endpoint streams binary back; use axios directly with
  // responseType:'blob' so we can hand the bytes to the browser as a download.
  async function downloadPdf(params) {
    try {
      const headers = { Authorization: `Bearer ${cookies.get('accesToken')}` }
      const response = await axios.get(`${baseURL}/reservations/report`, {
        params: { ...params, format: 'pdf' },
        headers,
        responseType: 'blob',
        timeout: 120000,
      })
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `reservas-${params.from || ''}-${params.to || ''}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      addToast(notificationTypes.error, 'Error al descargar PDF')
    }
  }

  return [{ reportState }, { generateReport, downloadPdf }]
}

export default useReservationsReportApi
